import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-cancel-button',
  templateUrl: './cancel-button.component.html',
  styleUrls: ['./cancel-button.component.scss'],
})
export class CancelButtonComponent implements OnInit {
  defaultTime = 5;
  runningTimer = 5;
  counterInterval: any;
  timeoutReference: any;

  @Output() actionCancelled = new EventEmitter<boolean>();
  @Output() actionTimeout = new EventEmitter<boolean>();

  constructor(public sbRef: MatSnackBarRef<CancelButtonComponent>) {}

  ngOnInit(): void {
    this.counterInterval = setInterval(() => {
      this.runningTimer--;
    }, 1000);
    this.timeoutReference = setTimeout(() => {
      this.actionTimeout.emit(true); // Emit an event when timeout occurs
      this.sbRef.dismiss(); // Optionally dismiss the snackbar
    }, 5000);

    // Listen for dismissal with action
    this.sbRef.afterDismissed().subscribe(() => {
      // @ts-ignore
      if (this.sbRef.dismissWithAction) {
        this.actionCancelled.emit(true); // Emit event when canceled
      }
      this.resetNotify();
    });
  }

  resetNotify() {
    this.runningTimer = this.defaultTime;
    clearInterval(this.counterInterval);
    clearTimeout(this.timeoutReference);
  }
}
